var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "traffic-container"
  }, [_c('div', {
    staticClass: "traffic_item mb_80"
  }, [_vm._m(0), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.metroList,
      "border": "",
      "header-cell-class-name": "header-row",
      "cell-style": {
        textAlign: 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "line",
      "label": "地铁线路"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "station",
      "label": "下车地点"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start",
      "label": "始发/终点站"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "首发/末班"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fee",
      "label": "全部票价"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "traffic_item"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.busList,
      "border": "",
      "header-cell-class-name": "header-row",
      "cell-style": {
        textAlign: 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "line",
      "label": "公交线路"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "station",
      "label": "下车地点"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start",
      "label": "始发/终点站"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "首发/末班"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fee",
      "label": "全部票价"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "news_wrap"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "news_container"
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news_item"
    }, [_c('div', {
      style: ({
        'backgroundImage': 'url(' + item.img + ')'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "item_title media_font_size_50"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "item_date media_font_size_30"
    }, [_vm._v(_vm._s(item.date))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "default_btn media_font_size_50",
    on: {
      "click": function($event) {
        return _vm.handelJump('/newsCenter?tab=0')
      }
    }
  }, [_vm._v("查看更多")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "co_wrap"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "swiper-container coswiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.logoList), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slide"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "default_btn media_font_size_50"
  }, [_vm._v("查看更多")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "traffic_type"
  }, [_c('div', [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v("地铁")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "traffic_type"
  }, [_c('div', [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v("公交路线")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video_wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_vm._v("广州国际车展")]), _vm._v(" "), _c('span', [_vm._v("AUTOSHOW")])]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gz_19_video.mp4",
      "controls": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v("展会新闻")]), _vm._v(" "), _c('span', [_vm._v("NEWS")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map_wrap"
  }, [_c('img', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/map.png",
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v("合作媒体")]), _vm._v(" "), _c('span', {
    staticClass: "mb_80"
  }, [_vm._v("MEDIA")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1749ce9f","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/traffic.vue
// module id = null
// module chunks = 